import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef, SimpleChange, OnChanges, SimpleChanges } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
import * as _ from "lodash";

//constants

//validators
import { dropDownValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as enums from '../../enums/index'
import * as serv from '../../services/index'
import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { SubtradeChannelDropdownComponent } from '../../components/DomainData/SubtradeChannelDropdown.component';
import { TradeNameDropdownComponent } from '../../components/DomainData/TradeNameDropdown.component';
import { KeyAccountDropdownComponent } from '../../components/DomainData/KeyAccountDropdown.component';
import { TradeGroupDropdownComponent } from '../../components/DomainData/TradeGroupDropdown.component';
import { FullServicePricingTypeDropdownComponent } from '../../components/DomainData/FullServicePricingTypeDropdown.component';
import { VendPackageLineItemGridComponent } from '../../components/Grids/VendPackageLineItemGrid.component';
import { CustomersAutoCompleteComponent } from '../Customers/CustomersAutoComplete.component';
import { MessageHandlerComponent } from '../Controls/MessageHandler.component';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';
import { CustomerOwnershipDropdownComponent } from '../DomainData/CustomerOwnershipDropdown.component';

@Component({
    selector: 'my-pricing',
    templateUrl: './Pricing.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => PricingComponent) }]
})
export class PricingComponent extends BaseControlGroupComponent{

    pricingForm: FormGroup;
    pricingInfo: ent.PricingInfo = new ent.PricingInfo();
    primaryGroupOverride: ent.PrimaryGroupOverride;
    primaryGroupOverrides: ent.PrimaryGroupOverride[];
    customers: ent.Customer[] = [];
    showNewPrimaryGroupName: boolean;
    oldCRTNumber: string = "";
    businessTypeID: number = Constants._NONE;
    isAddCommissionPayerTextboxDisabled: boolean = false;
    isCreatePayerNumberCheckboxDisabled: boolean = false;

    @Input() public requestTypeID: number;
    @Input() public selectDefaultTradeName: boolean;
    @Input() public selectDefaultKeyAccount: boolean;
    @Input() public selectDefaultTradeGroup: boolean;

    @Input() public showVendPackageLineItems: boolean;
    @Input() public showPrimaryFranchiseGroup: boolean;
    @Input() public showSecondaryFranchiseAgreementsGroup: boolean;
    @Input() public showOverarchingProgramsGroup: boolean;
    @Input() public showCommissionPaymentFrequency: boolean;
    @Input() public showCommissionPayerNumber: boolean;
    @Input() public showCreatePayerNumber: boolean;
    @Input() public showFullServicePricingType: boolean;
    @Input() public showNewContractCustomer: boolean;
    @Input() public showCustomerOwnership: boolean;

    @Input() public requireSubtradeChannel: boolean;
    @Input() public requireTradeName: boolean;
    @Input() public requireKeyAccount: boolean;
    @Input() public requireTradeGroup: boolean;
    @Input() public requireCommissionPaymentFrequency: boolean;
    @Input() public requirePrimaryFranchiseGroup: boolean;
    @Input() public requireFullServicePricingType: boolean;
    @Input() public requireCustomerOwnership: boolean;

    @Output() public customerOwnershipChanged: EventEmitter<number> = new EventEmitter();
    @Output() public primaryGroupOverrideChanged: EventEmitter<ent.PrimaryGroupOverride> = new EventEmitter();



    @ViewChild(SubtradeChannelDropdownComponent) public subtradeChannelDropdown: SubtradeChannelDropdownComponent;
    @ViewChild(TradeNameDropdownComponent) public tradeNameDropdown: TradeNameDropdownComponent;
    @ViewChild(KeyAccountDropdownComponent) public keyAccountDropdown: KeyAccountDropdownComponent;
    @ViewChild(TradeGroupDropdownComponent) public tradeGroupDropdown: TradeGroupDropdownComponent;
    @ViewChild(FullServicePricingTypeDropdownComponent) public fullServicePricingTypeDropDown: FullServicePricingTypeDropdownComponent;
    @ViewChild(CustomerOwnershipDropdownComponent) public customerOwnershipDropdownComponent: CustomerOwnershipDropdownComponent;
    @ViewChild(VendPackageLineItemGridComponent) public vendPackageLineItemGrid: VendPackageLineItemGridComponent;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild('customerAC') public customerAC: CustomersAutoCompleteComponent;

    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.pricingInfo = request.PricingInfo;
        if (request.VendPackageLineItems && this.vendPackageLineItemGrid) {
            this.vendPackageLineItemGrid.lineItems = request.VendPackageLineItems;
        }

        //this.crtNumberChanged(false);

        if (this.pricingInfo.PrimaryGroupCustomerNumbers) {
            var customerNumbers = this.pricingInfo.PrimaryGroupCustomerNumbers.split(',');
            if (customerNumbers.length > 0){
                var filter: filters.CustomerFilter = {CustomerNumbers: customerNumbers}
                this.customerService.getCustomers(filter).subscribe(x=>{
                   this.customers = x; 
                });
            }
        }
    }

    constructor(fb: FormBuilder, private customerService: serv.CustomerService) {
        super();
        let group = {
            'subtradeChannel': '',
            'hidSubtradeChannel': '',
            'tradeName': '',
            'newContractCustomer': '',
            'crtNumber': '',
            'keyAccount': '',
            'tradeGroup': '',
            'primaryFranchiseGroup': '',
            'secondaryFranchiseAgreementsGroup': '',
            'overarchingProgramsGroup': '',
            'commissionPayerNumber': '',
            'commissionPaymentFrequency': '',
            'hidCommissionPaymentFrequency': '',
            'createPayerNumber': '',
            'fullServicePricingType': '',
            'hidFullServicePricingType': '',
            'customerOwnership': '',
            'hidCustomerOwnership': '',
            'newPrimaryGroupName': '',
        };

        this.pricingForm = fb.group(group);

    }

    customerOwnershipLoadDone(event: any) {
        // if (this.pricingInfo && (this.pricingInfo.RequestID == undefined || this.pricingInfo.RequestID == 0)) {
        //      this.customerOwnershipDropdownComponent.value = enums.CustomerOwnershipEnum.Franchisee;
        // }
    }

    keyAccountLoadDone(event: any) {
        this.domainDataService.getPrimaryGroupOverrides().subscribe(x => {
            this.primaryGroupOverrides = x;

            var keyAccounts = this.keyAccountDropdown.keyAccounts.filter(x => x.ID == event);
            if (keyAccounts.length > 0) {
                this.keyAccountChange(keyAccounts[0]);
            }
            this.crtNumberChanged(false);
        });


    }

    ngOnInit(): void {

        if (this.requestTypeID == enums.RequestTypeEnum.SoldToCustomer) {
            this.businessTypeID = enums.BusinessTypeEnum.DSD;
        }
        if (this.requireSubtradeChannel) {
            this.pricingForm.controls['subtradeChannel'].setValidators(dropDownValidator);
            this.pricingForm.controls['hidSubtradeChannel'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireTradeName) {
            this.pricingForm.controls['tradeName'].setValidators(Validators.required);
        }

        if (this.requireKeyAccount) {
            this.pricingForm.controls['keyAccount'].setValidators(Validators.required);
        }

        if (this.requireTradeGroup) {
            this.pricingForm.controls['tradeGroup'].setValidators(Validators.required);
        }

        if (this.requirePrimaryFranchiseGroup) {
            this.pricingForm.controls['primaryFranchiseGroup'].setValidators(Validators.required);
        }

        if (this.requireCommissionPaymentFrequency) {
            this.pricingForm.controls['commissionPaymentFrequency'].setValidators(dropDownValidator);
            this.pricingForm.controls['hidCommissionPaymentFrequency'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireFullServicePricingType) {
            this.pricingForm.controls['fullServicePricingType'].setValidators(dropDownValidator);
            this.pricingForm.controls['hidFullServicePricingType'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireCustomerOwnership) {
            this.pricingForm.controls['customerOwnership'].setValidators(dropDownValidator);
            this.pricingForm.controls['hidCustomerOwnership'].setValidators(hiddenDropDownValueValidator);
        }

    }

    subtradeChannelSelected() {
        var val = true;
        var form = this.pricingForm;
        if (form.controls.subtradeChannel.errors && form.controls.hidSubtradeChannel.errors) {
            if (form.controls.subtradeChannel.errors.invalid && form.controls.hidSubtradeChannel.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    commissionPaymentFrequencySelected() {
        var val = true;
        var form = this.pricingForm;
        if (form.controls.commissionPaymentFrequency.errors && form.controls.hidCommissionPaymentFrequency.errors) {
            if (form.controls.commissionPaymentFrequency.errors.invalid && form.controls.hidCommissionPaymentFrequency.errors.invalid) {
                val = false;
            }
        }
        return val;
    }
    
    isCommissionPayerTextboxDisabled(){
        var val = this.isAddCommissionPayerTextboxDisabled;
        if (val){
            return 'disabled';
        }
        return null;
    }

    disableCreateCommissionPayerTextbox(event: boolean){
        this.isAddCommissionPayerTextboxDisabled = event;
    }
    
    disableCreatePayerNumberCheckbox(event: boolean, text: string){
        this.isCreatePayerNumberCheckboxDisabled = event;
        var val = this.isCreatePayerNumberCheckboxDisabled;
        if(val){
            if(text.length > 0){
                text = null;
                return 'disabled'
            } else {
                text = null;
                return 'enabled'
            }
        }
        return null;
    }

    fullServicePricingTypeSelected() {
        var val = true;
        var form = this.pricingForm;
        if (form.controls.fullServicePricingType.errors && form.controls.hidFullServicePricingType.errors) {
            if (form.controls.fullServicePricingType.errors.invalid && form.controls.hidFullServicePricingType.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    customerOwnershipSelected() {
        var val = true;
        var form = this.pricingForm;
        if (form.controls.customerOwnership.errors && form.controls.hidCustomerOwnership.errors) {
            if (form.controls.customerOwnership.errors.invalid && form.controls.hidCustomerOwnership.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    newContractCustomerChange(checked: boolean) {
        if (checked) {
            this.crtNumberChanged();
        }
        else {
            this.showNewPrimaryGroupName = false;
        }
    }

    setBusinessType(businessTypeID: number) {
        
        this.businessTypeID = businessTypeID;
        
    }

    showNewContractCustomerWrapper() : boolean {
        return this.showNewContractCustomer && this.businessTypeID == enums.BusinessTypeEnum.DSD;
    }

    showCRTNumber(): boolean {
        return this.pricingInfo.NewContractCustomer;
    }

    subtradeChannelChange(event: any) {
        this.pricingInfo.SubtradeChannelID = event;
    }

    tradeNameChange(event: any) {
        this.pricingInfo.TradeNameID = event;
    }

    tradeGroupChange(event: any) {
        this.pricingInfo.TradeGroupID = event;
    }

    commissionPaymentFrequencyChange(event: any) {
        this.pricingInfo.CommissionPaymentFrequencyID = event;
    }

    fullServicePricingTypeChange(event: any) {
        this.pricingInfo.FullServicePricingTypeID = event;
    }

    crtNumberChangedWrapper(value: any) {
        this.crtNumberChanged();
    }

    crtNumberChanged(callKeyAccountChangeWrapper: boolean = true) {
        if (!this.pricingInfo.NewContractCustomer) {
            return;
        }
        var filter: filters.CustomerRoiToolFilter = {CRTNumber: this.pricingInfo.CRTNumber};
        var pgFound: boolean = false;

        this.domainDataService.getCustomerRoiTools(filter).subscribe(x=>{
            var keyAccounts: ent.KeyAccount[];
            if (x.length == 1){
                var primaryGroup = x[0].PrimaryGroup;
                if (primaryGroup != null && primaryGroup != ''){
                    keyAccounts = this.keyAccountDropdown.keyAccounts.filter(y => y.Code == primaryGroup);
                    if (keyAccounts.length == 1)
                    {
                        this.keyAccountDropdown.value = keyAccounts[0].ID;
                        if (callKeyAccountChangeWrapper) {
                            this.keyAccountChangeWrapper(keyAccounts[0]);
                        }
                        pgFound = true;
                    }
                }
            }
            if (!pgFound) {
                keyAccounts = this.keyAccountDropdown.keyAccounts.filter(x=>x.Code == Constants._DEFAULT_KEY_ACCOUNT_CODE);
                if (keyAccounts.length > 0){
                    this.keyAccountDropdown.value = keyAccounts[0].ID;
                    if (callKeyAccountChangeWrapper) {
                        this.keyAccountChangeWrapper(keyAccounts[0]);
                    }
                }
            }
            else {
                this.customers = [];
            }
            this.showNewPrimaryGroupName = !pgFound;
        });
    }

    selectedCustomerNumberChanged(customerNumbers: string[]) {
        if (customerNumbers && customerNumbers.length > 0) {
            var customerNumber = customerNumbers[0];

            if (this.customers.some(x=>x.CustomerNumber == customerNumber)) {
                this.messageHandlerComponent.handleResponse({Success: false, 
                    ValidationMessages: [{Category: "error", MessageText: `Customer ${customerNumber} has already been selected.`}]});
                return;
            }
            
            var filter: filters.CustomerFilter = {CustomerNumber: customerNumber};
            this.customerService.getCustomers(filter).subscribe(x=>{
                if (x.length > 0) {
                    this.customers.push(x[0]);
                    this.setCustomerNumbers();
                    this.customerAC.clear();
                }
            });

            
        }       
    }

    onDeleteCustomer(event: any, lineItem: ent.Customer) {
        this.customers = _.remove(this.customers, x => x.CustomerNumber !== lineItem.CustomerNumber);
        this.setCustomerNumbers();
    }

    setCustomerNumbers() {
        this.pricingInfo.PrimaryGroupCustomerNumbers = this.customers.map(x => x.CustomerNumber).join(',');
    }

    showCustomers(): boolean {
        return this.customers.length > 0;
    }

    keyAccountChangeWrapper(keyAccount: ent.KeyAccount) {

        this.keyAccountChange(keyAccount);
        if (keyAccount.DefaultSubtradeChannelID != undefined && keyAccount.DefaultSubtradeChannelID > 0) {
            this.subtradeChannelDropdown.value = keyAccount.DefaultSubtradeChannelID;
        } else {
            this.subtradeChannelDropdown.value = Constants._NONE;
        }

    }

    keyAccountChange(keyAccount: ent.KeyAccount) {
        this.pricingInfo.KeyAccountID = keyAccount.ID;
        this.pricingInfo.PrimaryFranchiseGroup = keyAccount.PrimaryFranchiseGroup;
        this.pricingInfo.SecondaryFranchiseAgreementsGroup = keyAccount.SecondaryFranchiseAgreementsGroup;
        this.pricingInfo.OverarchingProgramsGroup = keyAccount.OverarchingProgramsGroup;
        var pgos: ent.PrimaryGroupOverride[] = [];
        if (this.primaryGroupOverrides) {
            pgos = this.primaryGroupOverrides.filter(x => x.PrimaryGroup.trim() == keyAccount.Code.trim());
        }
        if (pgos.length > 0) {
            this.primaryGroupOverride = pgos[0];
            this.pricingForm.controls['customerOwnership'].setValidators(dropDownValidator);
            this.pricingForm.controls['hidCustomerOwnership'].setValidators(hiddenDropDownValueValidator);
        }
        else {
            this.primaryGroupOverride = null; 
            if (this.customerOwnershipDropdownComponent) {
                this.customerOwnershipDropdownComponent.value = Constants._NONE;
            }
            this.pricingForm.controls['customerOwnership'].clearValidators();
            this.pricingForm.controls['hidCustomerOwnership'].clearValidators();
            //this.customerOwnershipDropdownComponent.value = enums.CustomerOwnershipEnum.Franchisee;
        }
        this.pricingForm.controls['customerOwnership'].updateValueAndValidity();
        this.pricingForm.controls['hidCustomerOwnership'].updateValueAndValidity();


        this.primaryGroupOverrideChanged.emit(this.primaryGroupOverride);

        if (keyAccount.Code != Constants._DEFAULT_KEY_ACCOUNT_CODE) {
            if (keyAccount.DefaultTradeGroupID != undefined && keyAccount.DefaultTradeGroupID > 0) {
                this.tradeGroupDropdown.value = keyAccount.DefaultTradeGroupID;
            }
            else {
                var tradeGroups = this.tradeGroupDropdown.tradeGroups.filter(x => x.Code == Constants._DEFAULT_TRADE_GROUP_CODE);
                if (tradeGroups.length > 0) {
                    this.tradeGroupDropdown.value = tradeGroups[0].ID;
                }
            }
        }
        

        if (keyAccount.Code != Constants._DEFAULT_KEY_ACCOUNT_CODE) {
            if (keyAccount.DefaultTradeNameID != undefined && keyAccount.DefaultTradeNameID > 0) {
                this.tradeNameDropdown.value = keyAccount.DefaultTradeNameID;
            }
            else {
                var tradeNames = this.tradeNameDropdown.tradeNames.filter(x => x.Code == Constants._DEFAULT_TRADE_NAME_CODE);
                if (tradeNames.length > 0) {
                    this.tradeNameDropdown.value = tradeNames[0].ID;
                }
            }
        }
    }

    customerOwnershipChange(event: any) {
        this.pricingInfo.CustomerOwnershipID = event;
        this.customerOwnershipChanged.emit(event);
    }

    disableCustomerOwnership(): boolean {
        if (this.primaryGroupOverride == undefined) {
            return true;
        }
        return false;
    }

}